import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    public isLoaderOn = new BehaviorSubject<boolean>(false);

    loadSpinner(status: boolean) {
        this.isLoaderOn.next(status);
    }
}